import { rootApi } from 'root-api'

// istanbul ignore file
// This file is a barrel export that only re-exports from other modules

/**
 * Meetings feature API.
 * Re-exports from the shared meetings API.
 * @deprecated This file is kept for backward compatibility.
 * New code should import directly from 'shared/api/meetings'.
 */

// Re-export all REST API hooks from shared API
export {
  useBlockInviteeMutation,
  useBookPollMutation,
  useCancelInviteeMutation,
  useCancelMeetingMutation,
  useDeletePendingEventMutation,
  useGetBuffersQuery,
  useGetInviteesQuery,
  useGetMeetingQuery,
  useGetMeetingsQuery,
  useGetPollResultsQuery,
  useGetTimelineDataQuery as useGetTimelineDataLegacyQuery,
  useLazyGetMeetingQuery,
  useLookupUuidsQuery,
  useMarkInviteeAsNoShowMutation,
  useUnblockInviteeMutation,
  useUndoNoShowForInviteeMutation,
  useUpdateBufferMutation,
  useUpdateEventAttributesMutation,
  useUpdateInviteeMutation,
  useUpdateMeetingMutation,
} from 'shared/api/meetings'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['EVENT_TYPE_LIST', 'EXPORTS_STATUS', 'PROFILE_EVENT_TYPE_LIST'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchEventTypesPolicy: build.query({
      query: (params = {}) => ({
        url: '/api/event_types/policy',
        params,
        validateStatus: (response) => (['200', '404'].includes(`${response}`))
      })
    })
  })
})

export const { useFetchEventTypesPolicyQuery } = api
